import { googleLogout } from '@react-oauth/google';
import { useState } from 'react';
import { Button, Card, Grid, Text } from '@mantine/core';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import {
  setGoogleAccount as setGoogleAccountRedux,
  setGoogleAnalyticsAccount as setGoogleAnalyticsAccountRedux,
} from '../../store/googleSlice';
import ErrorMessage from '../ErrorMessage';

const GoogleDisconnectButton = ({ setGoogleAccount }) => {
  const fetch = useFetch();
  const dispatch = useDispatch();
  const [error, setError] = useState();
  const [disabled, setDisabled] = useState(false);
  const { accountId, domainId } = useParams();

  const logout = async () => {
    setDisabled(true);
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/google/logout`, {
      method: 'POST',
    })
      .then(() => {
        googleLogout();
        setGoogleAccount(null);
        dispatch(setGoogleAccountRedux(null));
        dispatch(setGoogleAnalyticsAccountRedux(null));
      })
      .catch((error) => {
        console.log(error);
        setError('Google logout failed, please try again later or contact support!');
      });
  };

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Connection</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Button
              variant="filled"
              onClick={() => logout().finally(() => setDisabled(false))}
              disabled={disabled}
            >
              Disconnect Google from Releva
            </Button>

            <ErrorMessage message={error} />
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default GoogleDisconnectButton;
